import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import Card from "../components/Card";
import Button from "../components/Button";
import Select from "../components/Select";
import Input from "../components/Input";
import { listActions, sendCategory, stopSession } from "../api/bots";

export default function SessionDetail({ sessionId, onBack }) {
  const [category, setCategory] = useState("mutlu");
  const [targetMode, setTargetMode] = useState("all");
  const [strictUnique, setStrictUnique] = useState(true);
  const [botIndexesText, setBotIndexesText] = useState("");
  const [actions, setActions] = useState([]);
  const [err, setErr] = useState("");
  const [info, setInfo] = useState("");

  async function refresh() {
    const data = await listActions(sessionId);
    setActions(data.actions || []);
  }

  useEffect(() => {
    refresh().catch(() => {});
  }, [sessionId]);

  async function onSend() {
    setErr("");
    setInfo("");
    try {
      const payload = { category, targetMode, strictUnique };

      if (targetMode === "indexes") {
        const arr = botIndexesText
          .split(",")
          .map((x) => x.trim())
          .filter(Boolean)
          .map(Number)
          .filter((n) => Number.isFinite(n));
        payload.botIndexes = arr;
      }

      const r = await sendCategory(sessionId, payload);
      setInfo(`Gönderildi: ${r.sent}/${r.total}`);
      await refresh();
    } catch (e) {
      setErr(e.message);
    }
  }

  async function onStop() {
    setErr("");
    setInfo("");
    try {
      await stopSession(sessionId);
      setInfo("Stop gönderildi.");
      await refresh();
    } catch (e) {
      setErr(e.message);
    }
  }

  return (
    <Layout
      title="Session"
      right={
        <div style={{ display: "flex", gap: 8 }}>
          <Button variant="ghost" onClick={onBack}>Geri</Button>
          <Button variant="danger" onClick={onStop}>Stop</Button>
        </div>
      }
    >
      <div className="grid">
        <Card>
          <div className="h2">Komut Gönder</div>
          <div className="stack">
            <div className="muted mono">sessionId: {sessionId}</div>

            <Select
              label="Kategori"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              options={[
                { value: "mutlu", label: "mutlu" },
                { value: "uzgun", label: "uzgun" },
                { value: "tebrik", label: "tebrik" },
                { value: "nt", label: "nt" },
              ]}
            />

            <Select
              label="Hedef"
              value={targetMode}
              onChange={(e) => setTargetMode(e.target.value)}
              options={[
                { value: "all", label: "all (hepsi)" },
                { value: "half", label: "half (yarısı)" },
                { value: "indexes", label: "indexes (seçili botlar)" },
              ]}
            />

            {targetMode === "indexes" ? (
              <Input
                label="Bot Indexes (örn: 0,1,2)"
                value={botIndexesText}
                onChange={(e) => setBotIndexesText(e.target.value)}
              />
            ) : null}

            <Select
              label="Strict Unique"
              value={String(strictUnique)}
              onChange={(e) => setStrictUnique(e.target.value === "true")}
              options={[
                { value: "true", label: "true (hepsi farklı, yetmezse hata)" },
                { value: "false", label: "false (mesaj tekrar edebilir)" },
              ]}
            />

            {err ? <div className="error">{err}</div> : null}
            {info ? <div className="ok">{info}</div> : null}

            <Button onClick={onSend}>Gönder</Button>
          </div>
        </Card>

        <Card>
          <div className="h2">Actions</div>
          <div className="list">
            {actions.map((a) => (
              <div key={a.id} className="row">
                <div>
                  <div className="muted">
                    <b>{a.action_type}</b> | {a.category || "-"} | {a.target_mode} | by <b>{a.created_by_username}</b>
                  </div>
                  <div className="muted mono">{new Date(a.created_at).toLocaleString()}</div>
                </div>
              </div>
            ))}
            {actions.length === 0 ? <div className="muted">Log yok.</div> : null}
          </div>
        </Card>
      </div>
    </Layout>
  );
}
